import { useEffect } from 'react';
import type { ReactElement } from 'react';
import Footer from './Footer';

/** Browser tab title suffix for dining app (shared with pages that set title after async load). */
export function formatDiningDocumentTitle(segment: string): string {
  return `${segment} - Dining Steward`;
}

interface PageWithTitleProps {
  title: string;
  children: ReactElement;
}

export default function PageWithTitle({ title, children }: PageWithTitleProps) {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      const formattedTitle = formatDiningDocumentTitle(title);
      if (document.title !== formattedTitle) {
        document.title = formattedTitle;
      }
    }
  }, [title]);

  return (
    <div className="flex min-h-screen flex-col">
      <div className="flex min-h-0 flex-1 flex-col">{children}</div>
      <Footer />
    </div>
  );
}

